import React, { useState } from "react";
import { isMobileDevice } from "../../../utils/DeviceDetector";
import './WishlistSharingButton.css';
//import { CallToOrderClicked } from "../../../utils/Analytics";
//import { callToOrderNumber } from "../../../utils/StaticAssetManager";

const WishlistSharingButton = ({ className, isCentered, sharingType, sharingIcon, sharingLink, analyticsFunc, fontFamilyByStore }) => {
    //const phoneNumber = callToOrderNumber;
    const phoneNumber = '74128..'
    //const [showNumber, setShowNumber] = useState(false);
    const isMobile = isMobileDevice();
    const href = isMobile ? `tel:${phoneNumber}` : 'javascript:void(0)';

    const onNumberClick = () => {
        if (!isMobile) {
            // if (!showNumber) {
            //     CallToOrderClicked();
            // }
            // setShowNumber(!showNumber);
        } else {
            //CallToOrderClicked();
        }
    }

    const fireAnalytics = (e) => {
        console.log(analyticsFunc)
        analyticsFunc();
    }

    return <>
        <a onClick={fireAnalytics} className={`call-to-order-btn-wrapper ${className} ${isCentered ? 'margin15-auto' : ''}`} style={{ margin: isCentered ? '' : '15px 15px 10px' }} href={sharingLink} target="_blank">
            <span className="call-to-order-btn" style={{...fontFamilyByStore}} >{sharingType}</span>
            <img src={sharingIcon} />
        </a>
    </>
}

export default WishlistSharingButton;